/**
 * Could one day be published as https://npm.im/vue-debounce-watch
 *
 * Wraps the https://vuejs.org/v2/api/#vm-watch API with debounce for debounced watches!
 * Defaults to lodash debounce https://lodash.com/docs/#debounce for now, should move to an in-house debounce method?
 */
import _debounce from 'lodash/debounce';
import ms from 'ms';

export default function vueDebounceWatch(Vue, opts) {
  if (vueDebounceWatch.installed) {
    // Immediately return if this method has previously executed
    return;
  } else {
    vueDebounceWatch.installed = true;
  }

  if (!opts) {
    opts = {};
  }

  if (typeof opts.debounce !== 'function') {
    opts.debounce = (handler, wait) => _debounce(handler, wait);
  }

  Vue.mixin({
    created() {
      if (this.$options.debounceWatch) {
        try {
          validateDebounceWatch(this, this.$options.debounceWatch, opts);
        } catch (err) {
          console.error(err);
          console.warn('vue-debounce-watch is disabled');
          this.$options.debounceWatch = null;
        }
      }
    },
    mounted() {
      if (this.$options.debounceWatch) {
        this.$options._debounceWatchers = attachDebounceWatch(this, this.$options.debounceWatch, opts);
      }
    },
    beforeDestroy() {
      if (this.$options.debounceWatch) {
        removeDebounceWatch(this, this.$options._debounceWatchers, opts);
      }
    },
  });
};

function validateDebounceWatch(inst, map) {
  Object.keys(map).forEach(path => {
    const { handler, wait } = map[path];

    if (typeof wait !== 'string' && typeof wait !== 'number') {
      throw new TypeError(`Expected debounceWatch[${path}].wait to be a String or Number`);
    }

    if (typeof handler === 'string' && typeof inst.$options.methods[handler] === 'function') {
      // Make the handler in the map the reference to the instance method
      map[path].handler = inst.$options.methods[handler];
    } else if (typeof handler !== 'function') {
      throw new TypeError(`Expected debounceWatch[${path}].handler to be a function`);
    }
  });
}

function attachDebounceWatch(inst, map, { debounce }) {
  const watchers = {};

  Object.keys(map).forEach(path => {
    const { handler, wait, ...watchOpts } = map[path];

    const unwatch = inst.$watch(path, debounce(handler.bind(inst), ms(wait)), watchOpts);

    watchers[path] = unwatch;
  });

  return watchers;
}

function removeDebounceWatch(inst, watchers) {
  Object.keys(watchers).forEach(path => {
    const unwatch = watchers[path];
    unwatch();
  });
}



// WEBPACK FOOTER //
// ./src/plugins/vue-debounce-watch.js